import { useEffect, useMemo } from 'react'
import { useScalePoint } from 'hooks/useScalePoint'
import { useBreak } from 'hooks/useBreak'
import { vis_hoveredId, vis_label } from 'state/store.global';
import { useAtom } from 'jotai';
import { debounce } from 'utilities/debounce';
import { useRef } from 'react';

export const VERTICAL_VIEW_OFFSET = 90;

export const useZppSetup = (bounds, ref, dimensions, setScale, mode, pin) => {
  const isMobile = useBreak('md_dn');
  const setShowLabel = useAtom(vis_label)[1];
  const hoveredId = useAtom(vis_hoveredId)[0];
  const scale = useScalePoint(bounds, dimensions, mode, isMobile) + (isMobile ? (pin > 0 ? 0 : 0) : (pin > 0 ? 0 : 0));

   // useRef so the debounced fn is created once, not on every render
  const onZoomStop = useRef(
    debounce((id, show) => {
      id && show(true);
    }, 500)
  ).current;

  useEffect(() => {
    ref.current?.zoomToElement('center', scale, 0, null);
    ref.current?.centerView(scale, 0);
    if (!isMobile && ref.current) {
      const { positionX, positionY } = ref.current.state;
      ref.current.setTransform(positionX, positionY + VERTICAL_VIEW_OFFSET, scale, 0);
    }
    setScale(scale || 1);
  }, [scale, bounds, mode, setScale, ref, isMobile]);

  return useMemo(
    () => ({
      wrapperProps: {
        wheel: { step: 0.04 },
        limitToBounds: true,
        alignmentAnimation: { sizeX: 0, sizeY: 0 },
        zoomAnimation: { size: 0 },
        minScale: scale ?? 0,
        initialScale: scale ?? 1,
        maxScale: scale ? 8 : 0,
        onInit: (event) => {
          event.zoomToElement('center', scale, 0, null)
          event.centerView(scale, 0)
          if (!isMobile) {
            event.setTransform(event.state.positionX, event.state.positionY + VERTICAL_VIEW_OFFSET, scale, 0)
          }
          setScale(event.state.scale)
        },
        onZoom: (event) => {
          setShowLabel(false)
          setScale(event.state.scale)
        },
        onPinch: (event) => {
          setShowLabel(false)
          setScale(event.state.scale)
        },
        onZoomStop: () => onZoomStop(hoveredId, setShowLabel),
        disablePadding: true,
        // panning: { disabled: true }
      },
      wrapperStyle: {
        width: '100%',
        height: '100%',
        position: 'absolute',
        overflow: 'hidden',
        willChange: 'transform',
      },
      contentStyle: {
        width: dimensions.W,
        height: dimensions.H,
        overflow: 'hidden',
        willChange: 'transform',
      },
    }),
    [scale, dimensions, setScale, hoveredId],
  );
};
